import { getCookieDomain } from "../config/domains";

/**
 * Cookie storage partagé entre les deux applications d'une même famille de
 * domaines (artkiv.com ↔ vision.artkiv.com, ou plus tard artichaut.eu ↔
 * app.artichaut.eu ↔ vision.artichaut.eu). Le domaine du cookie est calculé
 * dynamiquement (voir getCookieDomain() dans src/config/domains.js) selon le
 * domaine réellement servi — un cookie ne peut avoir qu'un seul domaine à la
 * fois, donc pas de liste possible ici, contrairement aux origines auth.
 */
const MAX_AGE = 60 * 60 * 24 * 365; // 1 an

export const cookieStorage = {
  getItem: (key) => {
    const match = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${encodeURIComponent(key)}=`));
    if (!match) return null;
    try {
      return decodeURIComponent(match.split("=").slice(1).join("="));
    } catch {
      return null;
    }
  },

  setItem: (key, value) => {
    document.cookie = [
      `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
      `domain=${getCookieDomain()}`,
      "path=/",
      `max-age=${MAX_AGE}`,
      "SameSite=Lax",
      "Secure",
    ].join("; ");
  },

  removeItem: (key) => {
    document.cookie = [
      `${encodeURIComponent(key)}=`,
      `domain=${getCookieDomain()}`,
      "path=/",
      "max-age=0",
      "SameSite=Lax",
      "Secure",
    ].join("; ");
  },
};
